import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useStyles } from './style';
import { Button } from '@material-ui/core';

const EirActionButton = ({ variant = 'buttonMedium', type = 'contained', children, ...props }) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const buttonClass = `${classes.button} ${classes[variant]} ${classes[type]}`;
    return (
        <Button className={buttonClass} {...props}>
            {children}
        </Button>
    );
};

export default EirActionButton;
